<template>
  <div class="vfooter">
      <p>
        <a href="http://www.beian.miit.gov.cn" target="_blank"><span class="font-medium">沪ICP备15037760号-5&nbsp;&nbsp;&nbsp;Copyright ©2019  XOLO. All Rights Reserved</span></a>
      </p>
      
  </div>
</template>

<script>
export default {
  name: 'vfooter',
  data(){
    return{}
  },
  props: {

  }
}
</script>

<style scoped lang="less">
.vfooter{
  width: 100%;
  height: 53px;
  background-color: #333333;
  
  p{
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 53px;
    letter-spacing: 0px;
    color: #999999;;
    text-align: center;
  }
}
</style>